import React from "react";

import InteractiveHero from "../components/landing/interactive/InteractiveHero";
import ModernFooter from "../components/landing/modern/ModernFooter";
import Navbar from "../components/landing/modern/Navbar";
import PricingSection from "../components/landing/modern/PricingSection";
import SEOHead from "../components/tools/SEOHead";

// Structured data for the landing page (Organization + SoftwareApplication)
const structuredData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "name": "YouWo",
      "url": "https://youwo.ai",
      "logo": "https://youwo.ai/logo/youwoai-logo.png",
      "sameAs": [
        "https://twitter.com/youwoai",
        "https://www.linkedin.com/company/youwoai"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "email": "support@youwo.ai",
        "contactType": "customer support"
      }
    },
    {
      "@type": "SoftwareApplication",
      "name": "YouWo - AI That Does the Work for You",
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Web, iOS, Android, macOS",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD",
        "description": "Free tier available with premium and enterprise plans"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "ratingCount": "1000",
        "bestRating": "5"
      },
      "description": "Input-first AI agent that turns meetings, documents, and memory into source-grounded work."
    },
    {
      "@type": "WebSite",
      "url": "https://youwo.ai",
      "name": "YouWo",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://youwo.ai/tools?q={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    }
  ]
};

const ModernLandingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white selection:bg-blue-100 selection:text-blue-900">
      <SEOHead
        title="YouWo - AI That Does the Work for You"
        description="Turn recordings, files, and links into content, learning, and workflows."
        keywords="AI agent, AI workspace, meeting transcription, document AI, source citations, PDF summarizer, video summary, AI study tools, research assistant, follow-up automation"
        canonicalUrl="https://youwo.ai/"
        ogImage="https://youwo.ai/thumbnail.png"
        structuredData={structuredData}
      />
      <Navbar />
      <InteractiveHero />
      <PricingSection />
      <ModernFooter />
    </div>
  );
};

export default ModernLandingPage;
